{
    "action__edit": "Modifier",
    "action__copy_contact": "Copier le contact"
}
